const INIT_STATE = {
  selectedMachine: {}
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case "SELECTED_MACHINE": {
      return {
        ...state,
        selectedMachine: action.payload
      };
    }
    default:
      return state;

  }
}


